// src/pages/AboutPage.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./AboutPage.css";
import team from "../assets/team.png";

export default function AboutPage() {
    useEffect(() => {
      document.title = "AWR360ARABIC – قصتنا";
    }, []);
  return (
    <section className="about-page" dir="rtl">
      <h1 className="about-title">إذاعة صوت الحياة والأمل</h1>

      <div className="about-body">
        <p>
          تأسست إذاعة (AWR) في السبعينيات بهدف نشر رسالة الأمل عالميًا بلغات
          مختلفة. بدأت الشبكة باستخدام الموجات القصيرة، وتطورت لتصبح شبكة
          إعلامية متكاملة تبث برامجها بأكثر من 100 لغة، مستخدمة تقنيات حديثة
          مثل الأقمار الصناعية، والبث الرقمي، والإنترنت. تعد AWR من أوائل
          الإذاعات المسيحية التي خاطبت العالم العربي، حيث أنشأت استوديوهات
          إقليمية لإنتاج محتوى يتناسب مع احتياجات المنطقة، ولتوفير برامج متنوعة
          ومشجعة.
        </p>

        <p>
          من قلب هذه الشبكة، انطلقت إذاعة صوت الحياة والأمل في الأول من
          يونيو/حزيران 2022 من مدينة الناصرة بالأراضي المقدسة. نحن مؤسسة
          إعلامية مسيحية تبشيرية، نوفر لكم بثا مباشرا على مدار الساعة، بالإضافة
          إلى باقة من برامج البودكاست المتنوعة في الدين المسيحي، التربية،
          والصحة.
        </p>

        <p>
          في إذاعة صوت الحياة والأمل نؤمن أن كل صوت يستحق أن يُسمع، وكل قلب
          يستحق أن يجد الرجاء، وكل عقل يستحق أن يعثر على الاجابات التي يبحث
          عنها.
        </p>

        <p>
          رؤيتنا أن نكون منبرًا روحيًا وعصريا حيًا في قلب المجتمع، يزرع الإيمان،
          يغذي العقول، ويرسم دروب الرجاء. ندعوكم للانضمام إلينا في هذه الرحلة
          المباركة نحو حياة ملؤها الحياة والأمل.
        </p>
      </div>

      <div className="about-hero">
        <img src={team} alt="فريق صوت الحياة والأمل" />
      </div>
    </section>
  );
}
